import axios from "utils/axios";
import { stringify } from "query-string";

export const getNews = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/notifications/news/pagination?${query}`);
};
